import BsAccordion from "../components/BsAccordion";
import ResponsiveHelper from "../utils/ResponsiveHelper";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class Forum {
    constructor(dom) {
        this.dom = dom;
        window.addEventListener("resize", () => this.resize());
    }
    init() {
        gsap.registerPlugin(ScrollTrigger);
        this.initResponsiveHelper();
        this.initBsAccordion();
        this.initSectionControl();
    }

    initResponsiveHelper() {
        this.rHelper = new ResponsiveHelper();
        window.addEventListener("onBreakpointChange", (e) => {
        //console.log(e.detail);
        });
    }
    initBsAccordion() {
        const scAccordions = document.querySelectorAll(".m-schedule--item.accordion");
        if (scAccordions.length > 0) {
            scAccordions.forEach((accordion) => {
                accordion.addEventListener('hidden.bs.collapse', function () {
                    ScrollTrigger.refresh();
                })
                accordion.addEventListener('shown.bs.collapse', function () {
                    ScrollTrigger.refresh();
                })
            });

        }
    }

    initSectionControl() {
        let panels = gsap.utils.toArray(".part-sec");

        let tops = panels.map((panel) =>
        ScrollTrigger.create({ trigger: panel, start: "top top" })
        );

        panels.forEach((panel, i) => {
        ScrollTrigger.create({
            trigger: panel,
            start: () =>
            panel.offsetHeight < window.innerHeight ? "top top" : "bottom bottom", // if it's shorter than the viewport, we prefer to pin it at the top
            // panel.offsetHeight < window.innerHeight ? "top top" : "top top", // if it's shorter than the viewport, we prefer to pin it at the top
            end: "+=100%",
            pin: true,
            pinSpacing: false,
        });
        // ScrollTrigger.create({
        //   trigger: panel,
        //   start: "top top",
        //   pin: i === panels.length - 1 ? false : true,
        //   end: "bottom 100",
        //   pinSpacing: false,
        // });
        });
    }

    resize() {
        // console.log("resize from Homepage.js");
    }
}
